// Configuración para autenticación con Microsoft Entra ID (Azure AD)
// Este archivo contiene un placeholder para la futura integración con MSAL.js

import { Configuration, LogLevel } from '@azure/msal-browser'

/*
Para implementar Entra ID, el equipo de seguridad debe:

1. Instalar @azure/msal-browser:
   npm install @azure/msal-browser

2. Registrar la aplicación en Azure Portal:
   - Ir a Azure Active Directory > App registrations
   - Crear nueva aplicación
   - Configurar Redirect URIs (ej: https://tudominio.com, http://localhost:3000)
   - Copiar Application (client) ID y Directory (tenant) ID

3. Descomentar y configurar este archivo con los valores reales

4. Reemplazar AuthContext.tsx con implementación de MSAL
*/

export const msalConfig: Configuration = {
  auth: {
    clientId: (import.meta.env as Record<string, string | undefined>).VITE_ENTRA_CLIENT_ID?.trim() || '',
    authority: `https://login.microsoftonline.com/${(import.meta.env as Record<string, string | undefined>).VITE_ENTRA_TENANT_ID?.trim() || ''}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            // console.info(message)
            return
          case LogLevel.Verbose:
            // console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
        }
      },
    },
  },
}

export const loginRequest = {
  scopes: [],
}

/*
Ejemplo de implementación con MSAL:

import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig, loginRequest } from './authConfig'

const msalInstance = new PublicClientApplication(msalConfig)

// Login
await msalInstance.loginPopup(loginRequest)

// Logout
await msalInstance.logoutPopup()

// Get token
const accounts = msalInstance.getAllAccounts()
if (accounts.length > 0) {
  const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: accounts[0]
  })
  const token = response.accessToken
}
*/
